/// <reference path="interfaces.ts" />
var TotalJobsGroup;
(function (TotalJobsGroup) {
    var Header;
    (function (Header) {
        var Cookies = (function () {
            function Cookies(doc) {
                this.doc = doc || window.document;
            }
            Cookies.prototype.getCookieValue = function (name) {
                var matchedCookie = this.doc.cookie.match("(^|;)\\s*" + encodeURIComponent(name) + "\\s*=\\s*([^;]*)");
                return matchedCookie ? matchedCookie.pop() : null;
            };
            Cookies.prototype.setCookieValue = function (name, value, expiry, path) {
                var cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
                if (expiry) {
                    cookie += "; expires=" + expiry.toUTCString();
                }
                if (!path) {
                    path = "/";
                }
                cookie += "; path=" + path;
                this.doc.cookie = cookie;
            };
            return Cookies;
        }());
        Header.Cookies = Cookies;
    })(Header = TotalJobsGroup.Header || (TotalJobsGroup.Header = {}));
})(TotalJobsGroup || (TotalJobsGroup = {}));

//# sourceMappingURL=cookies.js.map
